<div class="ticket-cell full-width">
  <span class="label">Ticketnummer</span>
  <span>{{ ticket().crmIdentifier ?? '-' }}</span>
</div>

<div class="ticket-cell full-width">
  <span class="label">Titel</span>
  <span [innerHTML]="ticket().title"></span>
</div>

<div class="ticket-cell full-width">
  <span class="label">Erstellt am</span>
  <span>{{ ticket().createdAt | luxonDate }} – {{ ticket().createdAt | luxonDate: "T" }} Uhr</span>
</div>

@for (field of ticket().fields; track field.name) {
  @if (field.type !== 'group' && field.type !== 'file' && field.value) {
    <div class="ticket-cell full-width">
      <span class="label">{{ field.label }}</span>
      <span [innerHTML]="field.value"></span>
    </div>
  }

  @if (field.type === 'group' && (field.children?.length ?? 0) > 0) {
    <div class="full-width">
      <h3 class="text-headline-small">{{ field.label }}</h3>

      <table>
        <thead>
        <tr>
          @for (column of field.children![0]; track column.name) {
            <th>{{ column.label }}</th>
          }
        </tr>
        </thead>
        <tbody>
          @for (childGroup of field.children ?? []; track $index) {
            <tr>
              @for (child of childGroup; track child.name) {
                <td [innerHTML]="child.value"></td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (field.type === 'file' && field.files?.length) {
    <div class="ticket-cell full-width">
      <span class="label">{{ field.label }}</span>
      <div class="file-list">
        @for (file of field.files; track file.fileReference) {
          <span>{{ file.name }}</span>
        }
      </div>
    </div>
  }
}
